import * as React from "react";

/** Single phone/desktop breakpoint for the whole app (layout + map gesture lock). */
export const MOBILE_BREAKPOINT = 768;

function readIsMobile(): boolean {
  return typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT;
}

export function useIsMobile() {
  // Read width in the initial state so the first render already has the right
  // layout (otherwise desktop renders first and the map mounts twice).
  const [isMobile, setIsMobile] = React.useState<boolean>(readIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(readIsMobile());
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
